import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface OurBlogBoxProps {
    image: string;
    title?: string;
    excerpt?: string;
    slug?: string;
    author?: string;
    publishDate?: string;
    category?: string;
}

const OurBlogBox: React.FC<OurBlogBoxProps> = ({ image, title, excerpt, slug, author, publishDate, category }) => {
    const { t } = useTranslation();

    const formatDate = (dateString?: string) => {
        if (!dateString) return '10 Feb, 2024';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const truncateText = (text: string, maxLength: number) => {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    return (
        <div className="blog-box">
            <div className="blog-img-box">
                <div className="blog-img back-img" style={{backgroundImage: `url(${image})`}}>
                </div>
                <div className="blog-date">
                    <Link to={slug ? `/blog-detail?slug=${slug}` : "#"}>
                        <i className="fa fa-calendar" />{formatDate(publishDate)}
                    </Link>
                </div>
            </div>
            <div className="blog-text">
                {category && (
                    <span className="badge bg-primary mb-2" style={{ fontSize: '11px' }}>
                        {category}
                    </span>
                )}
                <h3 className="h3-title">
                    <Link to={slug ? `/blog-detail?slug=${slug}` : "/blog-detail"} title={title || "Blog title"}>
                        {title ? truncateText(title, 50) : "Maecenas non libero in nisi commodo."}
                    </Link>
                </h3>
                <p>{excerpt ? truncateText(excerpt, 100) : "Cras a erat vitae ex rutrum venenatis ut a nunc. Praesent turpis ipsum, maximus vitae lectus ut, sodales cursus leo."}</p>
                <div className="d-flex justify-content-between align-items-center">
                    <Link to={slug ? `/blog-detail?slug=${slug}` : "/blog-detail"}>
                        {t('blogCard.readMore')} <i className="fa fa-angle-right" />
                    </Link>
                    {author && (
                        <small className="text-muted">
                            <i className="fa fa-user me-1"></i>{author}
                        </small>
                    )}
                </div>
            </div>
        </div>
    );
};

export default OurBlogBox;